(ns frontend.ui.page.fund.core
  (:require
   [frontend.ui.page.fund.event :as event]
   [frontend.ui.page.fund.model :as model]
   [fx.ajax :as ajax]
   [re-frame.core :as rf]
   [ui.fx.toast :as toast]
   [ui.state.session.cofx :as session-cofx]))

(rf/reg-cofx
 ::request-id
 (fn [coeffects]
   ;; Unique across disposal and app-db resets, including logout/login.
   (assoc coeffects ::request-id (random-uuid))))

(defn get-fund-reports
  [{:keys [db]
    request-id ::request-id} [_ fund-id]]
  (let [request {:fund-id fund-id
                 :request-id request-id}]
    {:db (model/start-load db request)
     ::ajax/send {:operation :lp-portal/get-fund-reports
                  :body {:fund-id fund-id}
                  :on-ok [::event/lp-reports request]
                  :on-error [::event/lp-reports-failed request]}}))

(rf/reg-event-fx
 ::get-fund-reports
 [(rf/inject-cofx ::request-id)]
 get-fund-reports)

(rf/reg-event-db
 ::close-fund-reports
 (fn [db [_ fund-id]]
   (model/close db fund-id)))

(defn confirm-stop-reporting
  [{:keys [db]} [_ fund-id]]
  (when (:all-confirmed? (model/stop-reporting-dialog db fund-id))
    {:db (model/close-stop-reporting db fund-id)
     :dispatch [::discontinue-reporting fund-id]}))

(rf/reg-event-fx
 ::confirm-stop-reporting
 confirm-stop-reporting)

(defn discontinue-reporting
  [_cofx [_ fund-id]]
  {::ajax/send {:operation :lp-portal/discontinue-fund-reporting
                :body {:fund-id fund-id}
                :on-ok [::discontinue-reporting-ok fund-id]
                :on-error [::discontinue-reporting-failed fund-id]}})

(rf/reg-event-fx
 ::discontinue-reporting
 discontinue-reporting)

;; Load the reports again. The response has the discontinued state and the
;; report that the discontinue archived.
(rf/reg-event-fx
 ::discontinue-reporting-ok
 (fn [_cofx [_ fund-id _response]]
   {:dispatch [::get-fund-reports fund-id]}))

;; The state on the page can be out of date, for example after a new report
;; in another session. Load the reports again so that the menu shows why.
(rf/reg-event-fx
 ::discontinue-reporting-failed
 [(rf/inject-cofx ::session-cofx/session-context)]
 (fn [{:keys [session-context]} [_ fund-id _error]]
   (let [tr (:tr session-context)]
     {:fx [[::toast/error (tr :lp-stop-reporting-failed)]
           [:dispatch [::get-fund-reports fund-id]]]})))
